// extracted by mini-css-extract-plugin
export default {"main":"Popup_main__7S8s8","popup":"Popup_popup__DDMD3","icon":"Popup_icon__kabuL","text":"Popup_text__j8Qsb"};